/**
 * Adds Snowplow tracking events for OneTrust cookie banner
 * @param {Function} trackStructuredEvent - A tracker method that sends events to Snowplow
 * @param {object} trackingParams - Some tracking metadata, like locale and country
 * @returns {() => void)} - An event listener cleanup function
 */
const addTrackingEvents = (trackStructuredEvent, trackingParams) => {
  if (typeof document === 'undefined') return

  const getById = nodeId => document.getElementById(nodeId)

  // banner
  const bannerAcceptAllButton = getById('onetrust-accept-btn-handler')
  const bannerRejectAllButton = getById('onetrust-reject-all-handler')
  const bannerCookiePreferencesButton = getById('onetrust-pc-btn-handler')
  const bannerCookiePolicyLink = getById('ot-cookie-policy-link')
  const bannerPrivacyPolicyLink = getById('ot-privacy-policy-link')
  const bannerImprintLink = getById('ot-imprint-link')
  const bannerCloseButton = document.querySelector('.banner-close-button')

  // preference centre
  const pcAcceptAllButton = getById('accept-recommended-btn-handler')
  const pcRejectAllButton = document.querySelector('.ot-pc-refuse-all-handler')
  const pcConfirmButton = document.querySelector('.save-preference-btn-handler')
  const pcMoreInformationLink = document.querySelector('.privacy-notice-link')
  const pcCloseButton = getById('close-pc-btn-handler')

  const callbackMap = new Map([
    [
      bannerAcceptAllButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.accept_all_banner_clicked',
          label: trackingParams,
        }),
    ],
    [
      bannerRejectAllButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.reject_all_banner_clicked',
          label: trackingParams,
        }),
    ],
    [
      bannerCookiePreferencesButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.cookie_preferences_banner_clicked',
          label: trackingParams,
        }),
    ],
    [
      bannerCookiePolicyLink,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.cookie-policy_clicked',
          label: trackingParams,
        }),
    ],
    [
      bannerPrivacyPolicyLink,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.privacy-policy_clicked',
          label: trackingParams,
        }),
    ],
    [
      bannerImprintLink,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.imprint_clicked',
          label: trackingParams,
        }),
    ],
    [
      bannerCloseButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.close_clicked',
          label: trackingParams,
        }),
    ],
    [
      pcAcceptAllButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.accept_all_pc_clicked',
          label: trackingParams,
        }),
    ],
    [
      pcRejectAllButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.reject_all_pc_clicked',
          label: trackingParams,
        }),
    ],
    [
      pcConfirmButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.confirm_clicked',
          label: {
            ...trackingParams,
            activeGroups: window.OnetrustActiveGroups,
          },
        }),
    ],
    [
      pcMoreInformationLink,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.more-information_clicked',
          label: trackingParams,
        }),
    ],
    [
      pcCloseButton,
      () =>
        trackStructuredEvent({
          action: 'onetrust_cookie_banner.close_pc_clicked',
          label: trackingParams,
        }),
    ],
  ])

  // add click callbacks
  for (const [element, callback] of callbackMap) {
    if (element) {
      element.addEventListener('click', callback)
    }
  }

  // return event listener cleanup function
  return () => {
    for (const [element, callback] of callbackMap) {
      if (element) {
        element.removeEventListener('click', callback)
      }
    }
  }
}

export { addTrackingEvents }
